<div class="footer">
    <img src="/assets/Images/Orange_Footer.png" class="footer-img" alt="">
    <div class="footer-link">
    <div class="footerWrapper d-flex flex-row gap-3">
        <a class="footer-text" (click)="navigate('privacy')">Privacy Policy</a>
        <a class="footer-text" (click)="navigate('terms')">Terms and Conditions
        </a>
    </div>
</div>
</div>